import { render, staticRenderFns } from "./CardProjectWagestand.vue?vue&type=template&id=bd707162&scoped=true&"
import script from "./CardProjectWagestand.vue?vue&type=script&lang=js&"
export * from "./CardProjectWagestand.vue?vue&type=script&lang=js&"
import style0 from "./CardProjectWagestand.vue?vue&type=style&index=0&id=bd707162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd707162",
  null
  
)

export default component.exports